/**
 * The classifieds API rejects any `property.title.<locale>` longer than 60 characters. Checking
 * the same limit client-side keeps us from spending a serverless call on a doomed request.
 */
export const TITLE_MAX_LENGTH = 60;

export function isTitleTooLong(title: unknown): boolean {
    return typeof title === "string" && title.length > TITLE_MAX_LENGTH;
}

/**
 * Every locale that carries a title is sent to the API, so one over-long translation is enough
 * to get the whole payload rejected.
 */
export function hasOverLongTitle(titles: Record<string, unknown> | null | undefined): boolean {
    if (!titles) {
        return false;
    }

    return Object.keys(titles).some(function(locale: string): boolean {
        return isTitleTooLong(titles[locale]);
    });
}
